import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule } from '@angular/forms'; 

@Component({
  selector: 'app-mdl-select-campaign',
  standalone: true,
  imports: [CommonModule, NgSelectModule, FormsModule], 
  templateUrl: './mdl-select-campaing.html',
  styleUrls: ['./mdl-select-campaing.css']
})
export class MdlSelectCampaign {
  selectedCampaign: any;

  campaigns = [
    { id: 1, name: 'Campaña de Verano' },
    { id: 2, name: 'Campaña de Invierno' },
    { id: 3, name: 'Oferta Especial' }
  ];

  constructor(
    public dialogRef: MatDialogRef<MdlSelectCampaign>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  closeModal(): void {
    this.dialogRef.close();
  }

  saveSelection(): void {
    this.dialogRef.close(this.selectedCampaign);
  }
  
}